export default function setCookie(cookieName, cookieValue, expirationDays = 365) {
  const d = new Date();
  d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;

  document.cookie = `${cookieName}=${cookieValue};${expires};domain=.theknot.com;path=/`;
}
